import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  reason: Yup.string().trim().min(10).required(),
})
